import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";
import GeneralVoucherCodeReportCard from "../../admin/components/report/GeneralVoucherCodeReportCard";
import UniqueVoucherCodeReportCard from "../../admin/components/report/VoucherCodeReportCard";

const VoucherCodeReport = ({ token, distributor }) => {

    const history = useHistory();

    const [toggled, setToggled] = useState(false);

    useEffect(() => {
        if (!distributor || !distributor.voucher_code_report) {
            history.push("/distributor");
        }
    }, []);

    const handleToggle = () => {
        setToggled(!toggled);
    };

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={handleToggle} />
            <div className="admin-page">
                <Topbar handleToggle={handleToggle} />
                <div className="admin-content">
                    <GeneralVoucherCodeReportCard 
                        role="distributor"
                        token={token}
                    />

                    <UniqueVoucherCodeReportCard
                        role="distributor"
                        token={token}
                    />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    distributor: state.distributor.distributor,
    token: state.distributor.token,
});

export default connect(mapStateToProps)(VoucherCodeReport);